var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProPricing = function SvgIconProPricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_pro_pricing_svg__a)",
    d: "M6.36 18.56c0 .19.151.346.345.346h10.594c.19 0 .345-.156.345-.345V17.3H6.36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_pro_pricing_svg__b)",
    d: "M20.47 7.515a.35.35 0 0 0-.414.014L15.5 11.152l-3.198-5.89c-.117-.225-.483-.221-.604 0L8.5 11.151 3.944 7.529a.34.34 0 0 0-.41-.014.345.345 0 0 0-.135.39L6.23 16.61h11.543l2.828-8.706a.35.35 0 0 0-.131-.39"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_pro_pricing_svg__a",
    x1: 10.832,
    x2: 10.885,
    y1: 17.858,
    y2: 19.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_pro_pricing_svg__b",
    x1: 10.214,
    x2: 11.945,
    y1: 9.096,
    y2: 19.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9876"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B2"
  })))));
};
export default SvgIconProPricing;